/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Option_Writing_ModeInputs */



/**
* | output |
* | --- |
* | "Writing Mode" |
*
* @param {Compare_Event_Groups_Option_Writing_ModeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_option_writing_mode = /** @type {((inputs?: Compare_Event_Groups_Option_Writing_ModeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Option_Writing_ModeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode d'écriture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schreibmodus")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità di scrittura")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Режим письма")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo de escritura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("写作模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("執筆モード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लेखन मोड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Modo de escrita")
	return /** @type {LocalizedString} */ ("Writing Mode")
});